module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_section_heat.05b39.png";